// src/app/interceptors/error/error.interceptor.ts
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private _authService: AuthService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((res: HttpErrorResponse) => {
        switch (res.status) {
          case 401: // On unauthorized, redirect to login if authenticated
            if (this._authService.isAuthenticated) {
              this._authService.logout();
            }
            return throwError(() => res);

          case 0: // On empty status, backend is offline
            console.error('[ERR]: backend is offline');
            return throwError(() => res);

          case 500: // Internal server error, display generic error
            console.error('[ERR]: internal server error', res.error);
            return throwError(() => res);

          default: // Otherwise, return nice error message if available
            console.error('[ERR]: error in http response', res.error);
            return throwError(() => res);
        }
      })
    );
  }
}
